<div class="container mt-1">
  <div class="card shadow-sm">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
      <h4 class="mb-0">Employee Master</h4>

  <button type="button"
          class="btn btn-sm btn-light text-dark rounded-circle px-2 py-0"
          (click)="cancelEdit()">

    ✕

  </button>
    </div>

    <div class="card-body">
      <!--<form (ngSubmit)="onSubmit($event)">-->
      <div class="row g-3">



        <!-- Employee ID -->
        <div class="col-md-5">
          <label for="OD_EmployeeID" class="form-label">Employee ID</label>
          <input id="OD_EmployeeID" type="text" class="form-control form-control-sm" [(ngModel)]="add.Em_Empcode"
            name="OD_EmployeeID">
        </div>

        <!-- First Name -->
        <div class="col-md-5">
          <label for="firstName" class="form-label">First Name</label>
          <input id="firstName" type="text" class="form-control form-control-sm" [(ngModel)]="add.Em_Firstname"
            name="firstName">
        </div>

        <!-- Last Name -->
        <div class="col-md-5">
          <label for="lastName" class="form-label">Last Name</label>
          <input id="lastName" type="text" class="form-control form-control-sm" [(ngModel)]="add.Em_Lastname"
            name="lastName">
        </div>


        <!-- Designation -->
        <div class="col-md-5">
          <label for="designation" class="form-label">Designation</label>
          <select id="designation" class="form-select form-select-sm" [(ngModel)]="add.Em_Designation"
            name="designation">
            <option value="">-- Select --</option>
            <option *ngFor="let des of Designation" (value)="des.REM_REF_Name">{{des.REM_REF_Name}}</option>

          </select>
        </div>

        <!-- Grade -->
        <div class="col-md-5">
          <label for="grade" class="form-label">Location</label>
          <select id="grade" class="form-select form-select-sm" [(ngModel)]="add.Em_Grade" name="grade">
            <option value="">-- Select --</option>
            <option value="CHENNAI">Chennai</option>
            <option value="Hosur">Hosur</option>
          </select>
        </div>

        <!-- Date of Joining -->
        <div class="col-md-5">
          <label for="OD_Dateofjoin" class="form-label">Date of Joining</label>
          <input id="OD_Dateofjoin" type="date" class="form-control form-control-sm" [(ngModel)]="add.Em_DateofJoin"
            name="OD_Dateofjoin">
        </div>

        <!-- Plant -->
        <div class="col-md-5">
          <label for="plant" class="form-label">Plant</label>
          <select id="plant" class="form-select form-select-sm" [(ngModel)]="add.Em_Plant" name="Plant">
            <option value="">-- Select --</option>
            <option *ngFor="let pnt of plant" (value)="pnt.REM_REF_Name">{{ pnt.REM_REF_Name}}</option>
          </select>
        </div>

        <!-- Department -->
        <div class="col-md-5">
          <label for="Department" class="form-label">Department</label>
          <select id="Department" class="form-select form-select-sm" [(ngModel)]="add.Em_Department" name="Department">
            <option value="">-- Select --</option>
            <option *ngFor="let emp of departmentdata" (value)="emp.REM_REF_Name">{{ emp.REM_REF_Name}}</option>
          </select>
        </div>




        <!-- Reporter Designation -->
        <div class="col-md-5">
          <label for="Reporterdesignation" class="form-label">Role</label>
          <input id="Reporterdesignation" type="text" class="form-control form-control-sm" [(ngModel)]="add.Em_Roll"
            name="Reporterdesignation">
        </div>

        <div class="col-md-5">
          <label for="phoneno" class="form-label">Phone No</label>
          <input id="phoneno" type="text" class="form-control form-control-sm" [(ngModel)]="add.Em_PhoneNo"
            name="phoneno">
        </div>

        <div class="col-md-5">
          <label for="Adusername" class="form-label">AD User Name</label>
          <input id="Adusername" type="text" class="form-control form-control-sm" [(ngModel)]="add.Em_ADusername"
            name="Adusername">
        </div>
        <!-- Reporter Email -->
        <div class="col-md-5">
          <label for="ReporterMailid" class="form-label">Mail ID</label>
          <input id="ReporterMailid" type="email" class="form-control form-control-sm" [(ngModel)]="add.Em_Email"
            name="ReporterMailid">
        </div>
        <div class="col-md-5">
          <label for="CheckerApprover" class="form-label">Checker Approver</label>
          <select id="CheckerApprover" class="form-select form-select-sm" [(ngModel)]="add.Em_Checker_id"
            name="CheckerApprover">
            <option value="">-- Select --</option>
            <option *ngFor="let emp of CheckerApproverdata" [value]="emp.Em_iid">{{ emp.Em_First_Name + " " +
              emp.Em_lastName }}</option>
          </select>
        </div>



      </div>


      <!-- Submit Button -->
      <div class="d-grid mt-4">
        <button type="submit" class="btn btn-primary btn-lg" (click)="onSubmit()">Submit</button>


  <button type="button"
          class="btn btn-danger btn-lg"
          (click)="cancelEdit()">
    Cancel
  </button>
      </div>

    </div>
  </div>
</div>